// Removed unused initialState import
import CONSTANTS from '../../_constants';
import cartInitialState from '../state/cart';
import type { IFReduxCart } from '../state/cart';

export default function cartReducer(state: IFReduxCart = cartInitialState, action: any) {
  switch (action.type) {
    case CONSTANTS.CART_ACTIVE:
      return { ...state, cartActive: action.payload };
    case CONSTANTS.CART_UPDATE:
      return { ...state, current: action.payload };
    case CONSTANTS.CART_OPEN_MINICART:
      return { ...state, minicartOpen: action.payload };
    case CONSTANTS.CART_UPDATING:
      return { ...state, updating: action.payload };
    case CONSTANTS.CART_ADD:
      return { ...state, lastAdded: action.payload };
    case CONSTANTS.CART_FAIL:
    case CONSTANTS.CART_REMOVEITEM:
    case CONSTANTS.CART_CLEAR:
    default:
      return state;
  }
}